import React from "react";
import { getClassName } from "@sscs/utils";
import { FormDenseContext } from "./formDense";
const FormComponent = ({ horizontal = false, dense = false, children, className, ...formElementProps }) => {
    const classes = getClassName(className, {
        horizontal,
        dense,
    });
    return (React.createElement(FormDenseContext.Provider, { value: dense },
        React.createElement("form", { noValidate: true, ...formElementProps, className: classes }, children)));
};
export default FormComponent;
//# sourceMappingURL=FormComponent.js.map